import React from 'react';
import { Tag } from 'antd';

import { RightSidebar } from "src/pages/_partials/Layout";
import { UserNumberInterface } from "src/store/callrecorder/userNumbersSlice";
import RowInfo from "src/componets/RowInfo";
import OptionalLink from "src/componets/OptionalLink";
import { formattedDate } from "src/helpers/DateHelpers";
import callrecorderUrls from "src/configs/callrecorder/callrecorderUrls";

const boolTag = (val: boolean) =>
  val ? <Tag color="success">yes</Tag> : <Tag color="default">no</Tag>;

const _SidebarShow = ({ record }: { record: UserNumberInterface | undefined }) => {
  const renderDetails = () => {
    if (!record) {
      return null;
    }

    const caps = record.capabilities;

    return (
      <>
        <div className='v-mb-20'>
          <h6 className='v-content-label o-sm'>Identity</h6>

          <RowInfo left='#ID' right={record.id} />
          <RowInfo left='User' right={
            <OptionalLink link={callrecorderUrls.userPath(record.user_id)}>
              {`#${record.user_id}`}
            </OptionalLink>
          } />
          <RowInfo left='Number' right={record.number} />
          <RowInfo left='Friendly Name' right={record.friendly_name || '—'} />
          <RowInfo left='Type' right={
            (() => {
              const color = record.number_type === 'purchased' ? 'blue' : record.number_type === 'virtual' ? 'purple' : 'default';
              return <Tag color={color}>{record.number_type}</Tag>;
            })()
          } />
        </div>

        <div className='v-mb-20'>
          <h6 className='v-content-label o-sm'>Status</h6>

          <RowInfo left='Active' right={boolTag(record.active)} />
          <RowInfo left='SMS Verified' right={boolTag(record.sms_verified)} />
          <RowInfo left='Call Verified' right={boolTag(record.call_verified)} />
          <RowInfo left='Premium' right={boolTag(record.premium)} />
          <RowInfo left='Subscription' right={
            (() => {
              if (!record.subscription_status) return '—';
              const color = record.subscription_status === 'active' ? 'success'
                : record.subscription_status === 'pending' ? 'processing'
                : record.subscription_status === 'cancelled' ? 'warning'
                : record.subscription_status === 'expired' ? 'error'
                : 'default';
              return <Tag color={color}>{record.subscription_status}</Tag>;
            })()
          } />
          <RowInfo left='Unread SMS' right={record.unread_sms_count} />
        </div>

        {caps &&
          <div className='v-mb-20'>
            <h6 className='v-content-label o-sm'>Capabilities</h6>

            <RowInfo left='SMS Incoming' right={boolTag(caps.sms_incoming)} />
            <RowInfo left='SMS Outgoing' right={boolTag(caps.sms_outgoing)} />
            <RowInfo left='Call Incoming' right={boolTag(caps.call_incoming)} />
            <RowInfo left='Call Outgoing' right={boolTag(caps.call_outgoing)} />
            <RowInfo left='Domestic SMS Only' right={boolTag(caps.domestic_sms_only)} />
            <RowInfo left='Domestic Call Only' right={boolTag(caps.domestic_call_only)} />
          </div>
        }

        <div className='v-mb-20'>
          <h6 className='v-content-label o-sm'>References</h6>

          <RowInfo left='Virtual Number' right={record.virtual_number_id ? `#${record.virtual_number_id}` : '—'} />
          <RowInfo left='Phone Number' right={record.phone_number_id ? `#${record.phone_number_id}` : '—'} />
          <RowInfo left='State' right={record.state_id ? `#${record.state_id}` : '—'} />
        </div>
      </>
    )
  }

  return (
    <RightSidebar collapsible>
      <h6 className='v-content-label'>USER NUMBER DETAILS</h6>
      <hr className="v-divider" />

      {renderDetails()}
    </RightSidebar>
  )
}

export default _SidebarShow;
